import React, { useState, useEffect } from 'react'
import { Option, Select } from '../style'
import ApiService from '../../../services/ApiService'
import { companyComponentsProps, typesInterface } from '../types'

const SelectTypeComponent: React.FC<companyComponentsProps & { disabled?: boolean }> = (props) => {
  const { company, setCompany, disabled } = props
  const [types, setTypes] = useState<typesInterface[]>([])
  const [selectedTypeName, setSelectedTypeName] = useState<string>('')

  const handleSeachTypes = () => {
    ApiService.companies.getTypes()
      .then((response: any) => {
        if (response.data) setTypes(response.data)
      })
      .catch((error: any) => {
        console.log(error)
      })
  }

  useEffect(() => {
    handleSeachTypes()
  }, [])

  useEffect(() => {
    const selectedName = String(company?.companyTypes?.typeName || '').trim()
    const companyTypeId = company?.companyTypes?.id

    if (selectedName) {
      setSelectedTypeName(selectedName)
      return
    }

    const fallbackFromTypes = types.find((item) => {
      const itemIdNumber = Number(item?.id ?? -1)
      const companyTypeIdNumber = Number(companyTypeId ?? -1)

      if (companyTypeId !== undefined && companyTypeId !== null && !Number.isNaN(companyTypeIdNumber)) {
        if (Array.isArray(item.id)) return item.id.includes(companyTypeIdNumber)
        if (!Number.isNaN(itemIdNumber)) return itemIdNumber === companyTypeIdNumber
      }

      return String(item.typeName || '').trim().toLowerCase() === String(selectedName).trim().toLowerCase()
    })

    if (fallbackFromTypes && fallbackFromTypes.typeName) {
      setSelectedTypeName(String(fallbackFromTypes.typeName).trim())
      if (setCompany) {
        setCompany((prev: any) => ({ ...prev, companyTypes: fallbackFromTypes }))
      }
      return
    }

    setSelectedTypeName('')
  }, [company?.companyTypes, types, setCompany])

  const handleSetTypes = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const typeName = String(e.target.value || '').trim()
    setSelectedTypeName(typeName)

    if (setCompany) {
      const typeObject = types.find(obj => String(obj.typeName || '').trim() === typeName) || { typeName: typeName }
      setCompany((prev: any) => ({
        ...prev,
        companyTypes: typeObject
      }))
    }
  }

  console.log('🛰️ [SelectTypeComponent] company.companyTypes:', company?.companyTypes)
  console.log('🛰️ [SelectTypeComponent] selectedTypeName:', selectedTypeName)
  console.log('🛰️ [SelectTypeComponent] types loaded:', types)

  const trimmedTypes = types.map((item) => ({ ...item, typeName: String(item.typeName || '').trim() }))
  const hasSelectedOption = selectedTypeName && trimmedTypes.some((item) => item.typeName === selectedTypeName)

  const displayTypes = hasSelectedOption
    ? trimmedTypes
    : selectedTypeName
      ? [{ id: 0, typeName: selectedTypeName }, ...trimmedTypes]
      : trimmedTypes

  return (
    <Select value={selectedTypeName} onChange={handleSetTypes} onFocus={handleSeachTypes} disabled={disabled}>
      <Option value="">Selecione</Option>
      {displayTypes.map((item, index) => (
        <Option key={index} value={String(item.typeName || '').trim()}>{String(item.typeName || '').trim()}</Option>
      ))}
    </Select>
  )
}

export default SelectTypeComponent